<template>
    <!-- Modal -->
    <div class="modal fade" id="edit-password" tabindex="-1" aria-labelledby="edit-password" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Alterar Senha</h5>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label class="form-group" for="password">Senha</label>
                        <input class="form-control" type="password" id="password" v-model="fields.password">
                        <label class="form-group" for="password_confirmation">Confirmação de Senha</label>
                        <input class="form-control" type="password" id="password_confirmation" v-model="fields.password_confirmation">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" v-on:click="closeModal">Cancelar</button>
                    <button type="button" class="btn btn-primary" v-on:click="edit">Salvar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import $ from 'jquery'

    export default {
        name: "EditPasswordModal",

        data () {
            return {
                fields: {},
                errors: {}
            }
        },
        mounted () {
            this.index()
        },
        methods: {
            index () {
                this.fields = {
                    password: '',
                    password_confirmation: ''
                }
                this.errors = {}
            },
            closeModal () {
                this.index()
                $('#edit-password').modal('hide')
            },
            edit () {
                axios.put('/api/user/edit/password', this.fields)
                    .then(() => {
                        this.index()
                        this.closeModal()
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors
                        let message = ''
                        for (let i in this.errors) {
                            message = this.errors[i] + '<br />' + message
                        }
                        this.$swal({
                            title: 'Ops...',
                            text: message,
                            icon: 'error',
                            html: message
                        })
                    })
            }
        }
    }
</script>
